import { cn } from "@/shared/lib/utils";

interface ClientLogo {
  slug: string;
  name: string;
  src: string;
}

const LOGOS: readonly ClientLogo[] = [
  { slug: "klofac", name: "KLOFÁČ", src: "/hca-reference/klofac-logo.png" },
  { slug: "foreigners", name: "Foreigners Group", src: "/hca-reference/foreigners-logo.svg" },
  { slug: "knet", name: "K-net", src: "/hca-reference/knet-logo.svg" },
  { slug: "marais", name: "MARAIS", src: "/hca-reference/marais-logo.png" },
  { slug: "casagrey", name: "Casa GREY", src: "/hca-reference/casagrey-logo.png" },
  { slug: "thermoservis", name: "Thermoservis", src: "/hca-reference/thermoservis-logo.svg" },
  { slug: "humanit", name: "HumanIT", src: "/hca-reference/humanit-logo.png" },
];

interface LogoStripProps {
  variant?: "default" | "hero";
}

export function LogoStrip({ variant = "default" }: LogoStripProps) {
  const isHero = variant === "hero";

  // Marquee animates to -50%, takže obsah musí být ve dvou kopiích pro plynulý loop.
  const marqueeItems = [...LOGOS, ...LOGOS];

  return (
    <section
      className={cn("px-4", isHero ? "py-6" : "border-y border-border bg-background py-10")}
      data-testid="hca-home-logo-strip"
      aria-label="S kým spolupracujeme"
    >
      <div className="mx-auto max-w-6xl">
        <p
          className={cn(
            "mb-8 text-center text-xs font-semibold uppercase tracking-wider",
            isHero ? "text-[color:var(--hca-ivory)]/70" : "text-muted-foreground",
          )}
        >
          S kým spolupracujeme
        </p>
        <div className="hca-marquee-mask overflow-hidden" data-testid="hca-home-logo-strip-track">
          <ul className="hca-marquee flex w-max items-center gap-16">
            {marqueeItems.map((logo, idx) => (
              <li
                key={`${logo.slug}-${idx}`}
                className="flex shrink-0 items-center justify-center"
                aria-hidden={idx >= LOGOS.length ? "true" : "false"}
              >
                <img
                  src={logo.src}
                  alt={idx < LOGOS.length ? logo.name : ""}
                  className={cn(
                    "h-12 w-auto max-w-[160px] object-contain transition-opacity duration-300",
                    isHero
                      ? "opacity-80 brightness-0 invert hover:opacity-100"
                      : "opacity-80 hover:opacity-100",
                  )}
                  loading="lazy"
                  data-testid={`hca-home-logo-${logo.slug}`}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
